import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth, UnauthorizedError } from '@lib/hooks';
import { ComponentsTestId } from '@lib/testing';

var useScrolled = function useScrolled() {
  var _useState = useState(false),
    scrolled = _useState[0],
    setScrolled = _useState[1];
  useEffect(function () {
    var onScroll = function onScroll() {
      if (window.pageYOffset > 0) {
        setScrolled(true);
        return;
      }
      setScrolled(false);
    };
    window.addEventListener('scroll', onScroll);
    return function () {
      return window.removeEventListener('scroll', onScroll);
    };
  }, []);
  return scrolled;
};
var Header = function Header(_ref) {
  var onLogout = _ref.onLogout,
    home = _ref.home,
    children = _ref.children,
    headerStyle = _ref.headerStyle,
    _ref$overlay = _ref.overlay,
    overlay = _ref$overlay === void 0 ? false : _ref$overlay,
    _ref$showNavigation = _ref.showNavigation,
    showNavigation = _ref$showNavigation === void 0 ? true : _ref$showNavigation;
  var scrolled = useScrolled();
  var _useState2 = useState(false),
    active = _useState2[0],
    setActive = _useState2[1];
  var _useAuth = useAuth(),
    user = _useAuth.user,
    logout = _useAuth.logout;
  var lo = function lo() {
    logout();
    onLogout();
  };
  return /*#__PURE__*/React.createElement("header", {
    className: "header " + (overlay ? 'overlay' : '') + " " + (overlay && scrolled ? 'background' : '') + " " + headerStyle + " py-6 justify-between items-center row"
  }, home, showNavigation && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", {
    className: "mr-4 desktop-only row stack"
  }, children, user && /*#__PURE__*/React.createElement("span", {
    className: "cursor-pointer link",
    onClick: lo
  }, "Log out")), /*#__PURE__*/React.createElement("div", {
    className: "mobile-only hamburger mx-4 " + (active ? 'active' : ''),
    onClick: function onClick() {
      setActive(!active);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "filling"
  })), /*#__PURE__*/React.createElement("nav", {
    className: "side-navigation mobile-only " + (active ? 'active' : '')
  }, /*#__PURE__*/React.createElement("div", {
    className: "links",
    onClick: function onClick() {
      setActive(false);
    }
  }, children, user && /*#__PURE__*/React.createElement("div", {
    className: "cursor-pointer link",
    onClick: function onClick(e) {
      onLogout(e);
    }
  }, "Log out")))));
};

var styles = {"spinner":"_1ecop","animated":"_27SnZ","rotation":"_2sodP","circle":"_22Oyv","dash":"_3tGzq"};

var LoadingSpinner = function LoadingSpinner() {
  return /*#__PURE__*/React.createElement("div", {
    className: styles.spinner
  }, /*#__PURE__*/React.createElement("svg", {
    className: styles.animated,
    viewBox: "0 0 66 66"
  }, /*#__PURE__*/React.createElement("circle", {
    className: styles.circle,
    fill: "none",
    strokeWidth: "6",
    strokeLinecap: "round",
    cx: "33",
    cy: "33",
    r: "30"
  })));
};

var _iteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator")) : "@@iterator";
var _asyncIteratorSymbol = /*#__PURE__*/typeof Symbol !== "undefined" ? Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator")) : "@@asyncIterator";
function _catch(body, recover) {
  try {
    var result = body();
  } catch (e) {
    return recover(e);
  }
  if (result && result.then) {
    return result.then(void 0, recover);
  }
  return result;
}
function _finallyRethrows(body, finalizer) {
  try {
    var result = body();
  } catch (e) {
    return finalizer(true, e);
  }
  if (result && result.then) {
    return result.then(finalizer.bind(null, false), finalizer.bind(null, true));
  }
  return finalizer(false, result);
}

var useAsync = function useAsync(asyncFunction, immediate) {
  if (immediate === void 0) {
    immediate = true;
  }
  var _useState = useState(immediate),
    loading = _useState[0],
    setLoading = _useState[1];
  var _useState2 = useState(null),
    result = _useState2[0],
    setResult = _useState2[1];
  var _useState3 = useState(null),
    error = _useState3[0],
    setError = _useState3[1];
  var mounted = useRef(true);
  useEffect(function () {
    return function () {
      mounted.current = false;
    };
  }, []);
  var execute = useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    try {
      setLoading(true);
      setResult(null);
      setError(null);
      return Promise.resolve(_finallyRethrows(function () {
        return _catch(function () {
          return Promise.resolve(asyncFunction.apply(void 0, args)).then(function (r) {
            if (mounted.current) {
              setResult(r);
            }
            return r;
          });
        }, function (e) {
          if (mounted.current) {
            setError(e);
          }
          return null;
        });
      }, function (_wasThrown, _result) {
        if (mounted.current) {
          setLoading(false);
        }
        if (_wasThrown) throw _result;
        return _result;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  }, [asyncFunction]);
  useEffect(function () {
    if (immediate) {
      execute()["catch"](function () {});
    }
  }, [execute, immediate]);
  return {
    execute: execute,
    loading: loading,
    result: result,
    error: error
  };
};

var Login = function Login(_ref) {
  var contactEmail = _ref.contactEmail,
    onEnterEmail = _ref.onEnterEmail,
    onEnterCode = _ref.onEnterCode;
  var _useAuth = useAuth(),
    showLoginConfirm = _useAuth.showLoginConfirm,
    setShowLoginConfirm = _useAuth.setShowLoginConfirm,
    startLogin = _useAuth.startLogin,
    confirmLogin = _useAuth.confirmLogin;
  var _useAsync = useAsync(startLogin, false),
    onSubmitEmail = _useAsync.execute,
    startLoading = _useAsync.loading,
    emailError = _useAsync.error;
  var _useAsync2 = useAsync(confirmLogin, false),
    onConfirm = _useAsync2.execute,
    confirmLoading = _useAsync2.loading,
    confirmError = _useAsync2.error;
  var _useState = useState(''),
    email = _useState[0],
    setEmail = _useState[1];
  var _useState2 = useState(''),
    code = _useState2[0],
    setCode = _useState2[1];
  var _useState3 = useState(false),
    emailSubmitted = _useState3[0],
    setEmailSubmitted = _useState3[1];
  var onEmailChange = function onEmailChange(e) {
    setShowLoginConfirm(false);
    setEmail(e);
  };
  var requestNewCode = function requestNewCode() {
    void onSubmitEmail(email);
    setCode('');
  };
  var onSubmit = function onSubmit(e) {
    e.preventDefault();
    if (startLoading || confirmLoading) {
      return;
    }
    setEmailSubmitted(true);
    onEnterEmail === null || onEnterEmail === void 0 ? void 0 : onEnterEmail(email);
    void onSubmitEmail(email);
  };
  var completeLogin = function completeLogin(e) {
    e.preventDefault();
    if (startLoading || confirmLoading) {
      return;
    }
    onEnterCode === null || onEnterCode === void 0 ? void 0 : onEnterCode(email);
    void onConfirm(email, code);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, !showLoginConfirm && /*#__PURE__*/React.createElement("form", {
    className: "__my-1 column stack " + (emailSubmitted ? 'submitted' : ''),
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("div", {
    className: "label __mr-1"
  }, "Email"), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow column stack-small"
  }, /*#__PURE__*/React.createElement("input", {
    "data-test-id": ComponentsTestId.loginFormEmailInput,
    className: "input",
    type: "email",
    autoComplete: "email",
    name: "email",
    required: true,
    onChange: function onChange(e) {
      return onEmailChange(e.target.value);
    },
    value: email
  }), emailError && /*#__PURE__*/React.createElement("div", {
    className: "subtext error"
  }, emailError instanceof UnauthorizedError ? 'Email address not recognised' : 'An error occurred. Please try again'))), /*#__PURE__*/React.createElement("div", {
    className: "justify-end row"
  }, /*#__PURE__*/React.createElement("button", {
    "data-test-id": ComponentsTestId.loginFormSubmitButton,
    disabled: startLoading || confirmLoading,
    className: "btn " + (startLoading || confirmLoading ? 'loading-spinner' : ''),
    type: "submit"
  }, "SUBMIT", (startLoading || confirmLoading) && /*#__PURE__*/React.createElement(LoadingSpinner, null)))), showLoginConfirm && /*#__PURE__*/React.createElement("form", {
    className: "__my-1 column stack",
    onSubmit: completeLogin
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("div", {
    className: "label __mr-1"
  }, "Email"), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow column stack-small"
  }, /*#__PURE__*/React.createElement("input", {
    "data-test-id": ComponentsTestId.loginFormEmailInput,
    className: "input",
    type: "email",
    autoComplete: "email",
    name: "email",
    required: true,
    onChange: function onChange(e) {
      return onEmailChange(e.target.value);
    },
    value: email
  }))), /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("div", {
    className: "label __mr-1"
  }, "Please check your email for a login code"), /*#__PURE__*/React.createElement("div", {
    className: "flex-grow column stack-small"
  }, /*#__PURE__*/React.createElement("input", {
    "data-test-id": ComponentsTestId.loginFormLoginCode,
    className: "input",
    type: "number",
    inputMode: "numeric",
    placeholder: "Login Code",
    name: "token",
    required: true,
    onChange: function onChange(e) {
      return setCode(e.target.value);
    },
    value: code
  }), confirmError && /*#__PURE__*/React.createElement("div", {
    className: "subtext error"
  }, confirmError instanceof UnauthorizedError ? /*#__PURE__*/React.createElement(React.Fragment, null, "Login code is not valid, please try again or ", /*#__PURE__*/React.createElement("span", {
    className: "underline cursor-pointer",
    onClick: requestNewCode
  }, "request a new one")) : 'An error occurred. Please try again'))), /*#__PURE__*/React.createElement("div", {
    className: "justify-end row"
  }, /*#__PURE__*/React.createElement("button", {
    "data-test-id": ComponentsTestId.loginFormSubmitButton,
    disabled: startLoading || confirmLoading,
    className: "btn " + (startLoading || confirmLoading ? 'loading-spinner' : ''),
    type: "submit"
  }, "SUBMIT", (startLoading || confirmLoading) && /*#__PURE__*/React.createElement(LoadingSpinner, null)))), /*#__PURE__*/React.createElement("p", null, "If you can't login, please ", /*#__PURE__*/React.createElement("a", {
    className: "underline",
    href: "mailto:" + contactEmail
  }, "contact us.")));
};

var useDebounce = function useDebounce(fn) {
  var _useState = useState(false),
    firing = _useState[0],
    setFiring = _useState[1];
  var submit = function submit() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    try {
      if (firing) {
        return Promise.resolve();
      }
      setFiring(true);
      return Promise.resolve(_finallyRethrows(function () {
        return Promise.resolve(fn.apply(void 0, args));
      }, function (_wasThrown, _result) {
        setFiring(false);
        if (_wasThrown) throw _result;
        return _result;
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
  return submit;
};

export { Header, LoadingSpinner, Login, useAsync, useDebounce };
//# sourceMappingURL=index.js.map
